export var KbStatsOverivewType;
(function (KbStatsOverivewType) {
    KbStatsOverivewType[KbStatsOverivewType["UNIQUE_VISITORS"] = 0] = "UNIQUE_VISITORS";
    KbStatsOverivewType[KbStatsOverivewType["ARTICLES_PAGE_VIEW"] = 20] = "ARTICLES_PAGE_VIEW";
    KbStatsOverivewType[KbStatsOverivewType["SEARCHES"] = 10] = "SEARCHES";
    KbStatsOverivewType[KbStatsOverivewType["CONTACTED_SUPPORT"] = 1] = "CONTACTED_SUPPORT";
    KbStatsOverivewType[KbStatsOverivewType["SELF_HELP_SUCCESS"] = 2] = "SELF_HELP_SUCCESS";
})(KbStatsOverivewType || (KbStatsOverivewType = {}));
;
export var KbSearchTermType;
(function (KbSearchTermType) {
    KbSearchTermType[KbSearchTermType["POPULAR_SEARCHES"] = 11] = "POPULAR_SEARCHES";
    KbSearchTermType[KbSearchTermType["UN_EFFECTIVE_SEARCH_TERMS"] = 12] = "UN_EFFECTIVE_SEARCH_TERMS";
    KbSearchTermType[KbSearchTermType["EFFECTIVE_SEARCH_TERMS"] = 13] = "EFFECTIVE_SEARCH_TERMS";
    KbSearchTermType[KbSearchTermType["UN_ANSWERED_SEARCH_TERMS"] = 14] = "UN_ANSWERED_SEARCH_TERMS";
    KbSearchTermType[KbSearchTermType["SEARCH_TERM_CLICKED_ARTICLES"] = 15] = "SEARCH_TERM_CLICKED_ARTICLES";
    KbSearchTermType[KbSearchTermType["AVERAGE_POSITION"] = 16] = "AVERAGE_POSITION";
})(KbSearchTermType || (KbSearchTermType = {}));
export var KbStatsBreakdown;
(function (KbStatsBreakdown) {
    KbStatsBreakdown[KbStatsBreakdown["ALL"] = 0] = "ALL";
    KbStatsBreakdown[KbStatsBreakdown["SOURCE"] = 10] = "SOURCE";
})(KbStatsBreakdown || (KbStatsBreakdown = {}));
;
//# sourceMappingURL=kb.js.map